var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Modal from "react-modal";
import * as React from "react";
import { useState } from "react";
import { DescriptionBlock } from "@js/common/auth/components/descriptionBlock";
import { fetchApi, showError, showSuccess, translate } from "@js/common/helpers";
import { HttpMethods } from "tagwalk-api-client/assets/js/common/enums";
import { Title } from "@js/common/auth/components/title";
var AuthFirstNameLastNameModal = function (_a) {
    var user = _a.user, afterNameSubmit = _a.afterNameSubmit;
    var _b = useState(true), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = useState(''), firstName = _c[0], setFirstName = _c[1];
    var _d = useState(''), lastName = _d[0], setLastName = _d[1];
    var body = document.querySelector('body');
    if (!body) {
        return null;
    }
    Modal.setAppElement(body);
    var handleAfterSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var csrf_token, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (firstName == '' || lastName == '') {
                        showError('collection_rating.modal.auth_name.form.error.required_field');
                        return [2];
                    }
                    return [4, getCsrfToken()];
                case 1:
                    csrf_token = _a.sent();
                    if (csrf_token === null) {
                        return [2];
                    }
                    return [4, fetchApi('api_user_patch', HttpMethods.patch, { 'slug': user.slug }, { 'firstname': firstName, 'lastname': lastName, '_token': csrf_token !== null && csrf_token !== void 0 ? csrf_token : '' })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        showError('collection_rating.modal.auth_name.form.error.global');
                        return [2];
                    }
                    setIsModalOpen(false);
                    if (typeof afterNameSubmit === 'function') {
                        afterNameSubmit();
                    }
                    showSuccess('collection_rating.modal.auth_name.form.success', undefined, true);
                    return [2];
            }
        });
    }); };
    var getCsrfToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4, fetchApi('api_security_generate_csrf_token', HttpMethods.post, {}, { 'csrf_token_id': 'authenticate' })];
                case 1:
                    response = _a.sent();
                    return [4, response.json()];
                case 2:
                    data = _a.sent();
                    if (!response.ok) {
                        showError('collection_rating.form.error.global');
                        return [2, null];
                    }
                    return [2, data];
                case 3:
                    error_1 = _a.sent();
                    showError('collection_rating.form.error.global');
                    return [2, null];
                case 4: return [2];
            }
        });
    }); };
    return (React.createElement(Modal, { isOpen: isModalOpen, className: "tds" },
        React.createElement("div", { id: "authModalContent", className: "modal modal--open" },
            React.createElement("div", { className: "auth-body modal-body" },
                React.createElement(DescriptionBlock, null),
                React.createElement("div", { className: "right-block" },
                    React.createElement("div", { className: "form-section" },
                        React.createElement("div", { className: "logo flex-center" },
                            React.createElement("img", { src: "/images/watermark-black.png", alt: translate('auth.alt.logo') })),
                        React.createElement(Title, null, translate('collection_rating.modal.auth_name.title')),
                        React.createElement("form", { id: "nameForm", onSubmit: handleAfterSubmit },
                            React.createElement("div", { className: "form-group" },
                                React.createElement("input", { id: 'firstname', type: 'text', className: 'form-control', placeholder: translate('collection_rating.modal.auth_name.form.placeholder.firstname'), onChange: function (event) {
                                        setFirstName(event.target.value);
                                    } })),
                            React.createElement("div", { className: "form-group" },
                                React.createElement("input", { id: 'lastname', type: 'text', className: 'form-control', placeholder: translate('collection_rating.modal.auth_name.form.placeholder.lastname'), onChange: function (event) {
                                        setLastName(event.target.value);
                                    } })),
                            React.createElement("button", { id: "saveUpdate", type: "submit", className: "btn" }, translate('collection_rating.modal.auth_name.form.action.save')))))))));
};
export { AuthFirstNameLastNameModal };
